export default __webpack_public_path__ + "static/Mitsubishi-baa4fb9b97cf3812c6af10219d49cd6a.jpg";